import { useState } from 'react';
import { useSelector } from 'react-redux';
import * as _ from 'underscore';

type Obj = {
  [propName: string]: any;
};

type UseRoleGroupProps = {
  group: string | Obj;
  type: string | undefined;
  role_list?: Array<string>;
};

const useRoleGroup = ({ group, type = '', role_list }: UseRoleGroupProps) => {
  const { role_group_list } = useSelector((state: Obj) => (state && state[type]) || []);
  const name = ((group instanceof Object ? group.group : group) || '').toUpperCase();
  const [roleGroup, setRoleGroup] = useState(
    !!group && (role_list ? role_list : role_group_list || []).indexOf(group) > -1
  );
  return [roleGroup, setRoleGroup];
};

export default useRoleGroup;
